import { render, staticRenderFns } from "./q-bank-delete-popup.html?vue&type=template&id=bf66408a&scoped=true&external"
import script from "./q-bank-delete-popup.js?vue&type=script&lang=js&external"
export * from "./q-bank-delete-popup.js?vue&type=script&lang=js&external"
import style0 from "./q-bank-delete-popup.scss?vue&type=style&index=0&id=bf66408a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf66408a",
  null
  
)

export default component.exports